import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';
import { Row, Col, Modal } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import TableWidget from '../../TableWidget.js';
import { AddEditWeeklyOvertimeSetting } from './addEditOvertimeSettings.js';
import Button from '~/components/CustomButton/CustomButton';

//elements
import LoadingSpinner from '~/elements/LoadingSpinner';

//utils
import { shortDateFormat } from '~/utils/dateFormat';

//assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

const formatData = function (data, t, dateTimeRules) {
    return data.map(item => ({
        name: item.name,
        type: item.allow_overtime_averaging ? t('AML') : t('Normal'),
        isActive: item.is_active ? t('Active') : t('Inactive'),
        validity: (item.valid_from ? `${t("From")} ${shortDateFormat(item.valid_from, dateTimeRules)} ` : "- ") + (item.valid_to ? `- ${t("To")} ${shortDateFormat(item.valid_to, dateTimeRules)}` : ""),
        code: "non_deletable"
    }));
}

class WeeklyOvertimeSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            weeklyOvertimeSettingList: [],
            isEdit: false,
            editData: {},
            loading: false
        }
        this.updateData = this.updateData.bind(this);
        this.ruleActivation = this.ruleActivation.bind(this);
    }

    updateData = async (data) => {
        const { commonStore, t, clientStore } = this.props;
        if (data.hasError)
            return commonStore.addNotification(t(data.errors[0].error), null, 'warning');

        this.setState({ loading: true }, async () => {
            try {
                if (this.state?.editData?.id)
                    await clientStore.updateWeeklyOvertimeSetting(this.state.editData.id, data);
                else
                    await clientStore.saveWeeklyOvertimeSetting(data);
                commonStore.addNotification(t('Weekly Overtime setting saved successfully!'), null, 'success');
                this.loadData()
            } catch (err) {
                console.error(err)
                this.setState({ loading: false })
            }
        })
    }

    componentDidMount() {
        this.setState({ loading: true }, this.loadData);
    }

    loadData = async () => {
        const { clientStore } = this.props;
        try {
            const { weeklyOvertimeSettings } = await clientStore.getWeeklyOvertimeSettings();
            this.setState({
                weeklyOvertimeSettingList: weeklyOvertimeSettings || [],
                isEdit: false,
                loading: false,
            });
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
        }
    }

    editWeeklyOvertime = async (index) => {
        const { t, commonStore, clientStore } = this.props
        const data = this.state.weeklyOvertimeSettingList[index];
        this.setState({ loading: true });
        try {
            const weeklyOvertime = await clientStore.getWeeklyOvertimeSettingById(data.id);
            this.setState({ loading: false });
            this.toggleModal(true, weeklyOvertime);
        }
        catch (err) {
            commonStore.addNotification(t(err.message || 'Something went wrong!'), null, 'error');
            this.setState({ loading: false });
        }
    }

    toggleModal = (value, data) => {
        this.setState({ isEdit: value, editData: data });
    }

    activateDeactivate = (id, value) => {
        this.setState({ loading: true }, async () => {
            try {
                await this.props.clientStore.activationWeeklyOvertimeSetting(id, { status: value });
                this.loadData();
            } catch (err) {
                console.error(err);
                this.setState({ loading: false });
            }
        });
    }

    ruleActivation = (id, value) => {
        const { t } = this.props
        const message = value === 'active' ? 'Activating this rule will lock it from further changes' : 'Deactivating this rule will also deactivate all linked weekly overtime settings in user profiles';
        confirmAlert({
            title: t('Are You Sure?'),
            message: t(message) + '.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.activateDeactivate(id, value)
                },
                {
                    label: 'No'
                }
            ]
        });
    }

    render() {
        const { t, clientStore, commonStore } = this.props;
        const { isEdit, loading } = this.state
        const { overtimeSettingList } = clientStore;
        const dateTimeRules = commonStore.getDateTimeRules();
        if (loading) return <LoadingSpinner />

        return (
            <>
                <Row>
                    <Col xs={{ span: 4, offset: 8 }} className='d-flex justify-content-end mt-2'>
                        <Button wd fill onClick={() => this.toggleModal(true, {})}>
                            <i className="fa fa-plus-circle fa-xl margin-right-10" /> {this.props.t('Add new')}
                        </Button>
                    </Col>
                </Row>
                <TableWidget
                    headers={['Name', 'Type', 'Status', 'Validity']}
                    metaData={[
                        { field: 'name', type: 'text' },
                        { field: 'type', type: 'number' },
                        { field: 'isActive', type: 'text' },
                        { field: 'validity', type: 'text' }
                    ]}
                    data={formatData(this.state.weeklyOvertimeSettingList, t, dateTimeRules)}
                    page={'weeklyOvertimeSettings'}
                    onChange={_ => { }}
                    minRemoveIndex={0}
                    customDeleteHandler={_ => { }}
                    customFormHandler={this.editWeeklyOvertime}
                />
                <Modal
                    className={"modal right fade modal_revised"}
                    backdrop="static"
                    show={isEdit}
                    onHide={() => this.toggleModal(false, {})}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Weekly Overtime Settings')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.toggleModal(false, {})}
                        />
                    </Modal.Header>
                    <Modal.Body className='position-relative'>
                        <AddEditWeeklyOvertimeSetting
                            values={this.state.editData}
                            ruleActivation={this.ruleActivation}
                            updateData={this.updateData}
                            cancel={() => this.toggleModal(false, {})}
                            overtimeSettingList={overtimeSettingList}
                            t={t}
                            dateTimeRules={dateTimeRules}
                            clientStore={clientStore}
                            commonStore={commonStore}
                            handleDelete={this.props.handleDelete}
                        />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(withRemoveDialog(observer(WeeklyOvertimeSettings))));
